"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemsRequests = void 0;
var http_1 = require("../services/http");
var utils_1 = require("../services/utils");
var _helpers_1 = require("./_helpers");
//  POST   /collections/<collection_id>/items/move-first
//  POST   /collections/<collection_id>/items/move-last
//  POST   /collections/<collection_id>/items/move-before/<item_id>
//  POST   /collections/<collection_id>/items/move-after/<item_id>
// Generated by CoffeeScript 2.3.1
//  # Items API ...
//  POST   /collections/<collection_id>/items/prepend
//  POST   /collections/<collection_id>/items/append
//  POST   /collections/<collection_id>/items/insert-before/<item_id>
//  POST   /collections/<collection_id>/items/insert-after/<item_id>
//  POST   /collections/<collection_id>/items/update/<item_id>
//  POST   /collections/<collection_id>/items/delete/<item_id>
function normalize(res) {
    if (!res || !res.items) {
        return [];
    }
    return res.items
        .map(function (itemData) { return itemData && itemData.object; })
        .filter(Boolean)
        .map(utils_1.toClientModel);
}
exports.itemsRequests = {
    createAsFirst: function (collectionOrId, items) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/prepend",
            method: 'POST',
            data: {
                items: _helpers_1.toArray(items),
            },
        }).then(normalize);
    },
    createAsLast: function (collectionOrId, items) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/append",
            method: 'POST',
            data: {
                items: _helpers_1.toArray(items),
            },
        }).then(normalize);
    },
    createBefore: function (collectionOrId, items, beforeItemOrID) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        if (!_helpers_1.getId(beforeItemOrID)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/insert-before/" + _helpers_1.getId(beforeItemOrID),
            method: 'POST',
            data: {
                items: _helpers_1.toArray(items),
            },
        }).then(normalize);
    },
    createAfter: function (collectionOrId, items, afterItemOrID) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        if (!_helpers_1.getId(afterItemOrID)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/insert-after/" + _helpers_1.getId(afterItemOrID),
            method: 'POST',
            data: {
                items: _helpers_1.toArray(items),
            },
        }).then(normalize);
    },
    update: function (collectionOrId, items) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items",
            method: 'PUT',
            data: {
                items: _helpers_1.toArray(items),
            },
        }).then(normalize);
    },
    delete: function (collectionOrId, itemsOrIds) {
        var ids;
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        ids = _helpers_1.toArray(itemsOrIds).map(_helpers_1.getId);
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/delete",
            method: 'POST',
            data: {
                item_ids: ids,
            },
        }).then(normalize);
    },
    moveToStart: function (collectionOrId, itemsOrIds) {
        var ids;
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        ids = _helpers_1.toArray(itemsOrIds).map(_helpers_1.getId);
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/move-first",
            method: 'POST',
            data: {
                item_ids: ids,
            },
        }).then(normalize);
    },
    moveToEnd: function (collectionOrId, itemsOrIds) {
        var ids;
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        ids = _helpers_1.toArray(itemsOrIds).map(_helpers_1.getId);
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/move-last",
            method: 'POST',
            data: {
                item_ids: ids,
            },
        }).then(normalize);
    },
    moveBefore: function (collectionOrId, itemsOrIds, beforeItemOrID) {
        var ids;
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        if (!_helpers_1.getId(beforeItemOrID)) {
            return _helpers_1.getNoIdPromise();
        }
        ids = _helpers_1.toArray(itemsOrIds).map(_helpers_1.getId);
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/move-before/" + _helpers_1.getId(beforeItemOrID),
            method: 'POST',
            data: {
                item_ids: ids,
            },
        }).then(normalize);
    },
    moveAfter: function (collectionOrId, itemsOrIds, afterItemOrID) {
        var ids;
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        if (!_helpers_1.getId(afterItemOrID)) {
            return _helpers_1.getNoIdPromise();
        }
        ids = _helpers_1.toArray(itemsOrIds).map(_helpers_1.getId);
        return http_1.http({
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId) + "/items/move-after/" + _helpers_1.getId(afterItemOrID),
            method: 'POST',
            data: {
                item_ids: ids,
            },
        }).then(normalize);
    },
};
//# sourceMappingURL=items.js.map